<template>
    <div class="container-background-pagamento">
        <div class="container-header">
            <v-btn class="container-botao-voltar" depressed flat @click="voltar">
                <v-icon color="#EEEEEE">arrow_back</v-icon>
            </v-btn>
            <span class="text-header">Compras BR</span>
        </div>
        <div class="container-card">
            <div class="primeiro-container">
                <span class="text-label-container" v-if="plano">{{ plano.nome}}</span>
                <span class="text-label-container" v-else>---</span>
                <div class="info-container">
                    <span class="valor-plano-primeiro"
                          v-if="plano">Valor Plano: {{ plano.valor | valorParaReal }}</span>
                    <span class="text-label-container" v-else>---</span>
                    <v-btn depressed class="btn-container" color="#3a6861" @click="voltar">
                        Alterar Plano
                    </v-btn>
                </div>
            </div>
            <div class="segundo-container">
                <span class="text-label-container">SELECIONE A FORMA DE PAGAMENTO</span>
                <div class="radio-container">
                    <v-radio-group v-model="tipoPagamento">
                        <v-radio color="#3a6861" value="BOLETO">
                            <span slot="label" class="label-radio"><v-icon>local_atm</v-icon>Boleto Bancário</span>
                        </v-radio>
                        <v-radio color="#3a6861" value="CARTAO_CREDITO">
                            <span slot="label"><v-icon>payment</v-icon>Cartão de Crédito</span>
                        </v-radio>
                    </v-radio-group>
                    <v-btn
                            depressed
                            class="btn-pagar-container"
                            color="#3a6861"
                            @click="pagarPlano"
                            :disabled="!plano"
                            :loading="carregamento"
                    >
                        Pagar
                    </v-btn>
                </div>
            </div>
            <div class="terceiro-container">
                <v-img src="https://s3-sa-east-1.amazonaws.com/asaas-static/images/invoice/site-seguro.png" height="50"
                       width="50" contain/>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import moment from 'moment'

    export default {
        name: 'SelecionarTipoPagamento',
        data() {
            return {
                tipoPagamento: 'BOLETO',
                plano: null,
                carregamento: false
            }
        },
        async mounted() {
            this.verificarUsuarioFornecedor()
            await this.buscarPlanoSelecionado()
        },
        methods: {
            ...mapActions([
                actionTypes.BUSCAR_PLANO_POR_ID,
                actionTypes.INSERIR_ASSINATURA_FORNECEDOR,
                actionTypes.INSERIR_CLIENTE_FOURBILLING
            ]),
            verificarUsuarioFornecedor() {
                if (this.$store.state.loki.user.type !== 'EXTERNO') {
                    this.$router.push({name: 'licitacaoBusca'})
                }
            },
            async buscarPlanoSelecionado() {
                this.plano = await this.buscarPlanoPorId(this.$route.params.idPlano)
            },
            async pagarPlano() {
                try {
                    this.carregamento = true
                    await this.inserirClienteFourbilling()
                    const dados = {
                        dataPrimeiraCobranca: moment(new Date()).add(2, 'days').format('YYYY-MM-DD'),
                        dataLimite: moment(new Date()).format('YYYY-MM-DD'),
                        ciclo: this.plano.ciclo,
                        tipoPagamento: this.tipoPagamento,
                        valor: this.plano.valor,
                        idPlano: this.plano.id,
                        geraUmaCobranca: true
                    }
                    this.setMensagemLoading('Salvando a assinatura...')
                    const resposta = await this.inserirAssinaturaFornecedor(dados)
                    this.abrirGuiaPagamento(resposta)
                    this.$router.push({name: 'PlanoFaturas'})
                } catch (err) {
                    this.carregamento = false
                }
            },
            abrirGuiaPagamento(cobranca) {
                if (cobranca.tipoPagamento === 'BOLETO') {
                    window.open(cobranca.urlBoleto, '_blank');
                } else {
                    window.open(cobranca.urlFatura, '_blank');
                }
            },
            voltar() {
                this.$router.push({name: 'planos'})
            }
        }
    }
</script>

<style scoped lang="stylus">

    .container-background-pagamento
        height 100vh
        background-color #EEEEEE
        font-family Roboto, sans-serif
        line-height 1.5

        .container-header
            display flex
            align-items center
            height 50px
            background-color #3a6861
            color #EEEEEE

        .container-botao-voltar
            height 100%
            padding 0px
            margin 0px
            margin-right 20px
            border-right 2px solid rgba(12, 36, 56, 0.5)

        .text-header
            font-size 20px
            font-weight 400

        .container-card
            min-height 80%
            padding-top 80px
            display flex
            flex-direction column
            align-items center
            justify-content center

        .primeiro-container
            background-color white
            border-radius 10px
            width 500px
            height 150px
            margin-bottom 20px
            padding 20px

        .segundo-container
            background-color white
            border-radius 10px
            width 500px
            height 150px
            margin-bottom 20px
            padding 20px

        .terceiro-container
            background-color white
            border-radius 10px
            width 500px
            height 90px
            margin-bottom 20px
            display flex
            justify-content center
            align-items center

        .text-label-container
            color #3a6861
            font-size 16px
            font-weight bold

        .info-container
            display flex
            justify-content space-between
            align-items center
            margin-top 20px

        .btn-container
            border-radius 5px
            color white !important

        .btn-pagar-container
            color white !important
            border-radius 5px

        .valor-plano-primeiro
            font-size 14px
            font-weight bold
            color #555555

        .radio-container
            display flex
            justify-content space-between
            align-items center
            margin-top 20px

        .label-radio
            display flex
            align-items center
</style>